import { useMemo } from 'react';
import { shallow } from 'zustand/shallow';
import useBoundStore from 'store';
import { MarketTypes } from '../types';

export interface NotificationFilter {
  title: string | null;
  filter: {
    marketType?: MarketTypes;
    apartmentComplexIds: number[];
    wallMaterials: number[];
    facilityTypeIds: number[];
    bedroomCount: number[];
    priceTo: number | null;
    priceFrom: number| null;
    areaTo: number | null;
    areaFrom: number | null;
    pricePerSqMTo: number | null;
    pricePerSqMFrom: number | null;
    commissioningYearFrom: number | null;
    commissioningYearTo: number | null;
    floorCountFrom: number | null;
    floorCountTo: number | null;
    floorFrom: number | null;
    floorTo: number | null;
  };
}

const useNotificationCreateFilter = (): NotificationFilter => {
  const storeParams = useBoundStore(
    ({
      title,
      apartmentComplexIds,
      wallMaterials,
      facilityTypeIds,
      bedroomCount,
      priceTo,
      priceFrom,
      areaTo,
      areaFrom,
      pricePerSqMTo,
      pricePerSqMFrom,
      commissioningYearFrom,
      commissioningYearTo,
      floorCountFrom,
      floorCountTo,
      floorFrom,
      floorTo,
    }) => ({
      title,
      apartmentComplexIds,
      wallMaterials,
      facilityTypeIds,
      bedroomCount,
      priceTo,
      priceFrom,
      areaTo,
      areaFrom,
      pricePerSqMTo,
      pricePerSqMFrom,
      commissioningYearFrom,
      commissioningYearTo,
      floorCountFrom,
      floorCountTo,
      floorFrom,
      floorTo,
    }),
    shallow,
  );

  const createFilterData = useMemo(() => {
    const {
      title,
      apartmentComplexIds,
      wallMaterials,
      facilityTypeIds,
      bedroomCount,
      priceTo,
      priceFrom,
      areaTo,
      areaFrom,
      pricePerSqMTo,
      pricePerSqMFrom,
      commissioningYearFrom,
      commissioningYearTo,
      floorCountFrom,
      floorCountTo,
      floorFrom,
      floorTo,
    } = storeParams;

    const dataCreateFilter = {
      title: title,
      filter: {
        apartmentComplexIds,
        wallMaterials,
        facilityTypeIds,
        bedroomCount,
        priceTo: priceTo && Math.floor(priceTo),
        priceFrom,
        areaTo,
        areaFrom,
        pricePerSqMTo,
        pricePerSqMFrom,
        commissioningYearFrom,
        commissioningYearTo,
        floorCountFrom,
        floorCountTo,
        floorFrom,
        floorTo,
      },
    };
    return dataCreateFilter;
  }, [storeParams]);

  for (const [key, value] of Object.entries(createFilterData.filter)) {
    if ((Array.isArray(value) && !value.length) || value === null) {
      // @ts-ignore
      delete createFilterData?.filter?.[key as typeof IFilterObject];
    }
  }

  return createFilterData;
};

export default useNotificationCreateFilter;
